// DevicesFilters.js
import React from "react";
import "./DevicesFilters.css";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ListItem, ListItemText } from "@mui/material";
import no_image from "../../../../assets/Images/no-image.png"

const DevicesFilters = ({
  selectedDevices,
  handleDeviceChange,
  deviceOptions,
  showDifferencesOnly,
  setShowDifferencesOnly,
}) => {
  // Count the number of selected devices
  const selectedCount = selectedDevices.filter((device) => device).length;

  return (
    <div className="DevicesFilters">
      <div className="DevicesFilters-container">
        <div className="filter-row">
          <FormControlLabel
            label="Show Differences Only"
            control={
              <Checkbox
                name="differences"
                checked={showDifferencesOnly}
                onChange={(e) => {
                  setShowDifferencesOnly(e.target.checked);
                }}
                sx={{
                  color: "#239DAB",
                  "&.Mui-checked": { color: "#239DAB" },
                  "&:hover": {
                    color: "#239DAB",
                    backgroundColor: "rgba(35, 157, 171, 0.1)",
                  },
                }}
              />
            }
            sx={{ marginRight: 2 }}
          />
          <div className="dropdown-row">
            {selectedDevices.map((selectedDevice, index) => {
              // Filter out already-selected devices for this dropdown
              const filteredOptions = deviceOptions.filter(
                (option) =>
                  !selectedDevices.some(
                    (device, i) => device?.id === option.id && i !== index
                  )
              );

              // Disable clearing if only two devices are selected
              const disableClearable =
                selectedCount <= 2 && selectedDevice !== null;

              return (
                <Autocomplete
                  key={index}
                  options={filteredOptions}
                  getOptionLabel={(option) => option.label || ""}
                  filterOptions={(options, state) =>
                    options.filter((option) =>
                      option.label
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase())
                    )
                  }
                  onChange={(event, newValue) =>
                    handleDeviceChange(index, newValue)
                  }
                  value={selectedDevice || null}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  disableClearable={disableClearable}
                  renderOption={(props, option) => (
                    <ListItem
                      {...props}
                      key={option.id}
                      sx={{ display: "flex", alignItems: "center", gap: "8px" }}
                    >
                      <img
                        className="dropdown-option-image"
                        src={option.image ? option.image : no_image}
                        alt={option.label}
                        style={{
                          width: "50px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                      <ListItemText primary={option.label} />
                    </ListItem>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select Device"
                      InputProps={{
                        ...params.InputProps,
                        startAdornment: selectedDevice?.label ? (
                          <img
                            src={selectedDevice.image ? selectedDevice.image : no_image}
                            alt={selectedDevice.label}
                            style={{
                              width: "40px",
                              height: "auto",
                              marginRight: "8px",
                              objectFit: "contain",
                            }}
                          />
                        ) : null,
                      }}
                    />
                  )}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevicesFilters;
